import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getData } from "../../../../backend/api";

// Public product details page resolved by GS1 GTIN (GS1 Digital Link: /01/:gtin)
const Gs1Product = () => {
  const { gtin } = useParams();
  const [product, setProduct] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    document.title = `Product Details - BENZOL`;
    const fetchProduct = async () => {
      const response = await getData({}, `product/public/${gtin}`);
      if (response?.status === 200 && response.data?.response) {
        setProduct(response.data.response);
        setStatus("loaded");
      } else {
        setStatus("notfound");
      }
    };
    fetchProduct();
  }, [gtin]);

  const rowStyle = { padding: "10px", border: "1px solid #ddd" };

  const rows = product
    ? [
        ["Product Name", product.productName],
        ["Category", product.category?.title],
        ["Grade", product.grade?.title],
        ["API", [product.api1?.title, product.api2?.title].filter((t) => t && t !== "NIL").join(" / ")],
        ["ACEA", product.acea?.title],
        ["SPEC", product.countryOilGrade?.title],
        ["Packaging", product.packaging?.title],
        ["Country Version", product.countryVersion?.title],
        ["Part Number", product.partNumberCode],
        ["GS1 Barcode", product.gs1Barcode],
        ["GS1 Carton Barcode", product.gs1CartoonBarcode],
        ["Product name in Carton", product.description],
      ].filter(([, value]) => value && value !== "NIL")
    : [];

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <div style={{ width: "100%", maxWidth: "600px" }}>
        <h2 style={{ textAlign: "center" }}>BENZOL Lubricants</h2>
        {status === "loading" && <p style={{ textAlign: "center" }}>Loading product details...</p>}
        {status === "notfound" && <p style={{ textAlign: "center" }}>No product found for barcode {gtin}.</p>}
        {status === "loaded" && (
          <React.Fragment>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px", marginBottom: "20px" }}>
              <tbody>
                {rows.map(([label, value]) => (
                  <tr key={label}>
                    <td style={rowStyle}>
                      <strong>{label}</strong>
                    </td>
                    <td style={rowStyle}>{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {product.link && (
              <p style={{ textAlign: "center" }}>
                <a href={product.link} target="_blank" rel="noreferrer">
                  {product.link}
                </a>
              </p>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default Gs1Product;
